import { UM } from '../_components/tokens';

/**
 * TopBar UrbanMap — barre du haut visible sur la vraie appli.
 */
export function TopBar() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      height: 56, padding: '0 16px',
      background: UM.bg, borderBottom: `1px solid ${UM.border}`,
      flexShrink: 0, zIndex: 20,
    }}>
      <div style={{ position: 'relative', width: 220, flexShrink: 0 }}>
        <select
          defaultValue=""
          style={{
            width: '100%', appearance: 'none', padding: '8px 30px 8px 12px',
            borderRadius: 6, border: `1px solid ${UM.border}`, background: UM.bg,
            color: UM.text, fontSize: 13, cursor: 'pointer',
          }}
        >
          <option value="">Aucune sélection</option>
          <option value="s1">Sélection zone Part-Dieu</option>
          <option value="s2">Sélection projet Lyon 3</option>
        </select>
        <span style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', color: UM.textMuted, fontSize: 10, pointerEvents: 'none' }}>▾</span>
      </div>
      <button
        title="Changer de fond de carte"
        style={{
          width: 36, height: 36, border: `1px solid ${UM.border}`,
          borderRadius: 6, background: UM.bgHeader, cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0, padding: 0,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M2 5.5 9 2l7 3.5-7 3.5L2 5.5Z" stroke={UM.accent} strokeWidth="1.2" strokeLinejoin="round" />
          <path d="M2 9l7 3.5L16 9" stroke={UM.accent} strokeWidth="1.2" strokeLinejoin="round" />
          <path d="M2 12.5 9 16l7-3.5" stroke={UM.accent} strokeWidth="1.2" strokeLinejoin="round" />
        </svg>
      </button>
      <div style={{ position: 'relative', flex: 1, maxWidth: 480 }}>
        <input
          type="text"
          placeholder="Rechercher"
          style={{
            width: '100%', padding: '8px 12px 8px 34px', borderRadius: 6,
            border: `1px solid ${UM.border}`, background: UM.bg, color: UM.text,
            fontSize: 13, boxSizing: 'border-box',
          }}
        />
        <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: UM.textMuted, fontSize: 14 }}>⌕</span>
      </div>
      <button
        title="Recentrer sur ma position"
        style={{
          width: 36, height: 36, border: `1.5px solid ${UM.accent}`,
          borderRadius: '50%', background: UM.bg, cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0, padding: 0,
        }}
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <circle cx="7" cy="7" r="4" stroke={UM.accent} strokeWidth="1.3" />
          <circle cx="7" cy="7" r="1.4" fill={UM.accent} />
          <path d="M7 .5v2M7 11.5v2M.5 7h2M11.5 7h2" stroke={UM.accent} strokeWidth="1.3" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
}
